import { AnyAction } from 'redux';
import {
  AccountInfoState,
  DepartmentList,
  UserList,
  SmsSenderList,
  SmsTemplateList,
} from '~/types/accountInfo';
import * as actionTypes from '~/store/actions/actionTypes';

export interface SetDepartmentsAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_DEPARTMENTS;
  payload: DepartmentList;
}

export interface SetUsersAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_USER_LIST;
  payload: UserList;
}

export interface SetSmsSendersAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_SMS_SENDERS;
  payload: SmsSenderList;
}

export interface SetSmsTemplatesAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_SMS_TEMPLATE;
  payload: SmsTemplateList;
}

export interface SetTourCompletedAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_TOUR_COMPLETED;
  payload: boolean;
}

type AccountInfoActions =
  | SetUsersAction
  | SetDepartmentsAction
  | SetSmsSendersAction
  | SetSmsTemplatesAction
  | SetTourCompletedAction;

export const initialState: AccountInfoState = {
  users: [],
  departments: [],
  smsTemplates: [],
  smsSenders: [],
  tourCompleted: false,
  // TODO: Once whatsapp is added, bring the integrations here... accountIntegrations -> activeIntegrations: [],
};

const reducer = (
  state: AccountInfoState = initialState,
  action: AccountInfoActions | AnyAction // To handle other actions as the project is not fully typed yet
): AccountInfoState => {
  switch (action.type) {
    case actionTypes.ACCOUNT_INFO_SET_USER_LIST:
      return {
        ...state,
        users: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_DEPARTMENTS:
      return {
        ...state,
        departments: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_SMS_TEMPLATE:
      return {
        ...state,
        smsTemplates: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_TOUR_COMPLETED:
      return {
        ...state,
        tourCompleted: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_SMS_SENDERS:
      return {
        ...state,
        smsSenders: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
